"use client"

import { useState } from "react"

import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"

export function NewsletterFormIsland({ placeholder = "Email address", submitLabel = "Subscribe" }: { placeholder?: string; submitLabel?: string }) {
  const [sent, setSent] = useState(false)

  return (
    <form className="flex flex-col gap-3 sm:flex-row" onSubmit={(event) => { event.preventDefault(); setSent(true) }}>
      <Input type="email" required placeholder={placeholder} aria-label={placeholder} className="h-12 rounded-full bg-background" />
      <Button type="submit" className="h-12 rounded-full">{submitLabel}</Button>
      {sent && <p className="sr-only" role="status">Subscribed</p>}
    </form>
  )
}